<mat-card style="width: 100%; max-width: 100%; box-sizing: border-box;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title>
                    <div class="header-content">
                        <div class="title-section">
                            <mat-icon class="header-icon">local_hospital</mat-icon>
                            <h2>Patient Encounters</h2>
                        </div>
                    </div>
                </mat-card-title>
            </div>
            <div class="right gap-10 g-just-flex">
                <div class="action-buttons">

                    @if (canExport$ | async) {
                    <button mat-button (click)="onExportEncounters()">
                        <mat-icon>download</mat-icon>
                        Export
                    </button>
                    }
                </div>
            </div>
        </div>

    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content>
        <!-- Table Header with Filters -->
        @if (tableHeaderMappedFilterArray && tableHeaderMappedFilterArray.size > 0) {
        <app-table-header [patientsTableFilterArray]="tableHeaderMappedFilterArray!"
            [patientsFiltersFormControlObject]="tableHeaderFiltersFormControlObject">
        </app-table-header>
        }

        <!-- Table -->
        @if (tableDataSource.data.length > 0) {
        <div class="table-container">
            <table mat-table [dataSource]="tableDataSource.data" class="encounters-table td-over-tr">

                <!-- Period Column -->
                <ng-container matColumnDef="period">
                    <th mat-header-cell *matHeaderCellDef>Start Date</th>
                    <td mat-cell *matCellDef="let row">
                        <div class="top">
                            {{ row['period - start'] | date:'mediumDate' }}

                        </div>
                        <div class="bottom subtitle-text-color-2">
                            {{ row['period - start'] | date:'shortTime' }}
                        </div>
                    </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let row">
                        <span [appChips]="row['status']" [fontSize]="'14px'">
                            <!-- {{ row['status'] | titlecase }} -->
                        </span>
                    </td>
                </ng-container>

                <!-- Class Column -->
                <ng-container matColumnDef="class">
                    <th mat-header-cell *matHeaderCellDef>Class</th>
                    <td mat-cell *matCellDef="let row">
                        {{ row['classDisplay'] | na }}
                    </td>
                </ng-container>

                <!-- Type Column -->
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>Type</th>
                    <td mat-cell *matCellDef="let row">
                        {{ row['type'] | na }}
                    </td>
                </ng-container>

                <!-- Subject Column (conditional) -->
                <ng-container matColumnDef="subject">
                    <th mat-header-cell *matHeaderCellDef>Patient</th>
                    <td mat-cell *matCellDef="let row">
                        <span [appReferenceDisplay]="row['subject']"></span>
                    </td>
                </ng-container>

                <!-- Location Column -->
                <ng-container matColumnDef="location">
                    <th mat-header-cell *matHeaderCellDef>Location</th>
                    <td mat-cell *matCellDef="let row">
                        @if(row.isAdmitted){
                        <div class="top">
                            <span [appEmphasis]="row.isAdmitted">
                                Admitted
                            </span>
                        </div>
                        }
                        <span>
                            {{ row['location'] | na }}
                        </span>
                    </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let row" class="action-column">
                        <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="showRow(row)">
                                <mat-icon>visibility</mat-icon>
                                <span>View Details</span>
                            </button>
                            <!-- @if (['planned', 'arrived', 'in-progress'].includes(row['status'])) {
                            <button mat-menu-item>
                                <mat-icon>update</mat-icon>
                                <span>Update Status</span>
                            </button>
                            }
                            <button mat-menu-item>
                                <mat-icon>print</mat-icon>
                                <span>Print Summary</span>
                            </button> -->
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="showRow(row)"
                    class="clickable-row">
                </tr>
            </table>
        </div>
        } @else {
        <app-empty-state icon="local_hospital" title="No Encounters" message="There are no encounters to display.">
        </app-empty-state>
        }
    </mat-card-content>
</mat-card>